import { MOBILE_WIDTH, useIsMobile } from "hooks/useDeviceType";
import { Badge as BadgeOriginal } from "./element/Badge";
import { Title as TitleOriginal } from "./element/Title";
import DollarCalloutIcon from "img/home/dollar-callout.svg?react";
import HotAirBalloonIcon from "img/home/hot-air-balloon.svg?react";
import StreamerImage6 from "../../../img/home/streamer-6.svg?react";
import Cloud1 from "../../../img/home/cloud-1.svg?react";
import Cloud2 from "../../../img/home/cloud-2.svg?react";
import Cloud3 from "../../../img/home/cloud-3.svg?react";
import { motion, useInView } from "framer-motion";
import { Text } from "components/general/Text";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useRef } from "react";
export const FeaturePrices = () => {
  const isMobile = useIsMobile();
  return (
    <Container>
      <SubContainer>
        <HotAirBalloonAnimation />
        <Badge icon={DollarCalloutIcon} text="Prices" />
        <MainContentContainer>
          <TextContainer>
            <Title>Elevate your trading with our pioneering liquidity</Title>
            <Text
              textStyle="Paragraph"
              size="Mega"
              textCss={css`
                max-width: 1000px;
              `}
              shouldScale={true}
            >
              We utilize a blend of the most efficient liquidity aggregation models to ensure the
              best possible prices with the lowest execution costs.
            </Text>
          </TextContainer>
        </MainContentContainer>
      </SubContainer>
      <div style={{ position: "absolute", top: isMobile ? -428 : -414, right: 0, zIndex: 0 }}>
        <StreamerImage6 {...(isMobile ? { width: 88 } : {})} />
      </div>
    </Container>
  );
};

// Sub-components

const Container = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1;
`;

const HotAirBalloonAnimation = () => {
  const ref = useRef(null);
  const isVisible = useInView(ref);
  const isMobile = useIsMobile();

  return (
    <HotAirBalloonAnimationContainer>
      <div ref={ref} style={{ position: "relative", zIndex: 5 }}>
        <HotAirBalloonIcon
          css={css`
            width: 444px;
            @media (max-width: ${MOBILE_WIDTH}px) {
              width: 203px;
              height: 163px;
            }
          `}
        />
      </div>

      {isVisible && (
        <>
          <motion.div
            style={{
              position: "absolute",
              top: -20,
              left: isMobile ? -30 : -10,
              zIndex: 1,
            }}
            animate={{ left: isMobile ? 18 : 50 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          >
            <Cloud1 width={isMobile ? 53 : 113} />
          </motion.div>
          <motion.div
            style={{
              position: "absolute",
              top: isMobile ? -12 : 30,
              right: isMobile ? -60 : -80,
              zIndex: 6,
            }}
            animate={{ right: isMobile ? -10 : -4 }}
            transition={{ delay: 0.6, duration: 0.7 }}
          >
            <Cloud2 width={isMobile ? 108 : 230} />
          </motion.div>
          <motion.div
            style={{ position: "absolute", bottom: isMobile ? 22 : 88, left: -80, zIndex: 6 }}
            animate={{ left: isMobile ? -34 : -40 }}
            transition={{ delay: 0.7, duration: 0.7 }}
          >
            <Cloud3 width={isMobile ? 53 : 112} />
          </motion.div>
        </>
      )}
    </HotAirBalloonAnimationContainer>
  );
};

const HotAirBalloonAnimationContainer = styled.div`
  position: relative;
`;

const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
  margin-bottom: 40px;

  @media (max-width: ${MOBILE_WIDTH}px) {
    gap: 40px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
`;

const Title = styled(TitleOriginal)`
  margin-bottom: 24px;
  max-width: 800px;
`;

const Badge = styled(BadgeOriginal)`
  margin-top: 38px;
  margin-bottom: 28px;
`;
